import {FETCH_RESULT, LIST_RESULT} from "./types";

const init = {
    isLoading: false,
    list: [],
    filter: {}
};
const result = (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_RESULT:
            return {
                ...state,
                isLoading: true,
                filter: payload
            };
        case LIST_RESULT:
            return {
                ...state,
                isLoading: false,
                list: payload.data
            };
        default:
            return state;
    }

}

export default result;